// src/admin/components/dashboard/RevenueTarget.tsx
import React from 'react';

interface RevenueTargetProps {
  currentPercentage: number;
  revenueToday: number; // Changed to number
  currentSellsRevenue: number; // Changed to number
  target: string; // Still string as it's formatted by parent
  revenue: string; // Still string
  sells: string; // Still string
}

const RevenueTarget: React.FC<RevenueTargetProps> = ({
  currentPercentage,
  revenueToday,
  currentSellsRevenue,
  target,
  revenue,
  sells,
}) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (currentPercentage / 100) * circumference;

  // Helper to format currency for the descriptive text
  const formatCurrencySimple = (value: number) => {
    if (value >= 1000000 || value <= -1000000) {
      return `${(value / 1000000).toFixed(2)}M`;
    } else if (value >= 1000 || value <= -1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return `${value}`;
  };

  const revenueTodayFormatted = revenueToday < 0 ? `-${formatCurrencySimple(Math.abs(revenueToday))}` : formatCurrencySimple(revenueToday);

  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className="relative w-32 h-32 flex items-center justify-center">
        <svg className="w-full h-full transform -rotate-90">
          <circle
            className="text-gray-200"
            strokeWidth="8"
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx="50%"
            cy="50%"
          />
          <circle
            className="text-yellow-500"
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx="50%"
            cy="50%"
          />
        </svg>
        <div className="absolute text-2xl font-bold text-gray-800">
          {currentPercentage.toFixed(2)}%
        </div>
      </div>
      <p className="text-sm text-gray-600 mt-4 text-center">
        You succeed earn <span className="font-semibold">{revenueTodayFormatted}</span> today. Current Sells Revenue is <span className="font-semibold">{currentSellsRevenue}%</span>!
      </p>

      <div className="grid grid-cols-3 gap-4 w-full mt-6 text-sm">
        <div className="flex flex-col items-center">
          <span className="text-gray-500">Target</span>
          <span className="font-semibold text-gray-800 flex items-center">{target} <span className="text-green-500 ml-1">↑</span></span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-gray-500">Revenue</span>
          <span className="font-semibold text-gray-800 flex items-center">{revenue} <span className="text-green-500 ml-1">↑</span></span>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-gray-500">Sells</span>
          <span className="font-semibold text-gray-800 flex items-center">{sells} <span className="text-green-500 ml-1">↑</span></span>
        </div>
      </div>
    </div>
  );
};

export default RevenueTarget;